var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471 C512,105.443,494.833,88.276,473.655,88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 v-73.471H0V385.379z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.09,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M130.225,339.285c-2.613-1.501-64.018-37.216-64.018-92.113v-75.034h132.414v75.034 c0,54.897-61.405,90.612-64.018,92.113l-2.189,1.249L130.225,339.285z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "167.094,233.931 146.285,236.672 139.35,236.672 139.35,224.254 143.511,224.254  160.158,226.995 157.903,217.318 160.158,207.641 143.511,210.381 139.35,210.381 139.35,206.187 142.091,185.379 132.414,188.198  122.737,185.379 125.478,206.187 125.478,210.381 121.315,210.381 104.67,207.641 106.924,217.318 104.67,226.995 121.315,224.254  125.478,224.254 125.478,236.672 118.542,236.672 97.734,233.931 100.552,243.608 97.734,253.284 118.542,250.543 125.478,250.543  125.478,282.483 139.35,282.483 139.35,250.543 146.285,250.543 167.094,253.284 164.276,243.608 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M132.414,269.241c-9.118,0-16.938,5.532-20.302,13.419c-0.594-0.049-1.162-0.178-1.767-0.178 c-11.751,0-21.266,9.21-21.94,20.791c17.875,22.004,40.264,35.116,41.82,36.011l2.189,1.25l2.189-1.25 c1.556-0.894,23.945-14.006,41.82-36.011c-0.673-11.581-10.189-20.791-21.94-20.791c-0.605,0-1.174,0.129-1.767,0.178 C149.352,274.773,141.532,269.241,132.414,269.241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M194.207,176.552c0,0,0,52.966,0,70.621c0,52.966-61.793,88.276-61.793,88.276 s-61.793-35.31-61.793-88.276c0-17.655,0-70.621,0-70.621H194.207 M203.034,167.724h-8.828H70.621h-8.828v8.828v70.621 c0,57.428,63.537,94.394,66.241,95.94l4.38,2.503l4.38-2.503c2.705-1.546,66.241-38.513,66.241-95.94v-70.621v-8.828H203.034z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.385fd6b60f2aa5cfd7329e87b17368c8.svg";
export { ForwardRef as ReactComponent };